import { Component, OnInit } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { CurrencyPipe, PercentPipe } from '@techrules/pipelib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { EvalGoalInterface } from '@techrules/portallib';

@Component({
  selector: 'tech-simulation-init-bars',
  templateUrl: './simulation-init-bars.component.html',
  styleUrls: ['./simulation-init-bars.component.scss'],
})
export class SimulationInitBarsComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  private currencyContribution: string;
  public loadGrafCategory: boolean = true;
  public loadGrafAssetType: boolean = true;
  public loadGrafCurrency: boolean = true;
  public loadGrafRegion: boolean = true;
  public loadGrafSector: boolean = true;
  public textGrafCategory: string;
  public textGrafAssetType: string;
  public textGrafCurrency: string;
  public textGrafRegion: string;
  public textGrafSector: string;
  public loadingMpTable: boolean = true;
  public colsMpTable = [];
  public dataMpTable: any;

  constructor(
    private commonService: CommonService,
    private initcontributionService: InitcontributionService,
    private translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    private percentPipe: PercentPipe
  ) {}

  ngOnInit() {
    this.initcontributionService.currencyContribution$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: string) => {
        if (Object.entries(res).length !== 0) {
          this.currencyContribution = res;
          this.initcontributionService.evalGoalObj$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((resp: EvalGoalInterface) => {
              if (Object.entries(resp).length !== 0) {
                this.dataMpTable = this.filterMainDistribution(
                  resp.initial_investment
                );
                this.loadPmTable();
              }
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private loadPmTable() {
    this.loadingMpTable = false;
    let tokenHolding;
    let tokenWeight;
    this.translate.get('k000036').subscribe((text: string) => {
      //Token: Nombre
      tokenHolding = text;
    });
    this.translate.get('k001692').subscribe((text: string) => {
      //Token: Weight
      tokenWeight = text;
    });
    this.translate.get('k000306').subscribe((text: string) => {
      //Token: Value
      this.colsMpTable = [
        {
          dataField: 'asset_class_name',
          caption: tokenHolding,
          hidingPriority: 3,
        },
        {
          dataField: 'amount',
          caption: text,
          hidingPriority: 1,
          calculateDisplayValue: (rowData) => {
            // let currencySymbol = new CurrencyPipe();
            return this.currencyPipe.transform(
              rowData.amount,
              this.currencyContribution,
              '1.0-0'
            );
          },
        },
        {
          dataField: 'weight',
          caption: tokenWeight,
          hidingPriority: 3,
          calculateDisplayValue: (rowData) => {
            return this.percentPipe.transform(rowData.weight);
          },
        },
        {
          dataField: '',
          caption: '',
          hidingPriority: 3,
          cssClass: 'vertical-align-middle',
          cellTemplate: 'templateWeight',
        },
      ];
    });
  }

  public barColor(row) {
    return this.commonService.colorGrafic2[row.rowIndex];
  }

  public filterMainDistribution(dataDistribution) {
    let dataDistributionOK: any = [];
    dataDistribution.forEach((element) => {
      if (element.weight != 0) dataDistributionOK.push(element);
    });
    return dataDistributionOK;
  }
}
